(function(){
  // "Fly to cart" add-to-cart effect (2026-09-18).
  //
  // Derek's request: when someone taps Add to Cart, send a copy of the
  // product photo shooting up to the cart icon in the header — shrinking
  // and spinning as it goes — then a little bright flash when it lands, so
  // it's visually obvious the item is now in the cart.
  //
  // This is a purely cosmetic layer on top of every add-to-cart button
  // already built across the site (the main Y/M/M oil card, the oil
  // filter, the kit bundle, "Complete the job" cross-sell rows, Cleaning &
  // Detailing rows, the shared product-photo modal, the Shop-by-Job modal
  // cards, and the Shop-by-Brand product modal). Rather than editing each
  // of those files individually (one of them, flybyu-ymm.js, is a large
  // file that has hit Shopify's upload size ceiling before — see
  // collaboration-plan.md), this listens for clicks on all of their known
  // Add to Cart buttons from one shared, self-contained script and finds
  // each one's product photo generically. Nothing about how any of those
  // buttons actually add to cart is touched — this only ever reads the
  // DOM, never intercepts or blocks the click.
  //
  // Loaded once, sitewide, via a single line in layout/theme.liquid (the
  // same place flybyu-bike-info-bar.js is already loaded from), so it
  // covers every current and future page without needing a script tag
  // added to each section.

  // Each existing "Add to Cart" button, and how to find ITS product photo
  // from the button that was clicked. `ancestor` scopes the search to the
  // specific card/row/modal the button belongs to, for buttons that repeat
  // multiple times on a page (a list of cross-sell rows, a strip of job-
  // modal cards, etc). Buttons with no `ancestor` belong to a section that
  // only ever appears once per page, so the photo is looked up globally.
  var RULES = [
    { btn: '[data-fby-oil-add-btn]',          img: '[data-fby-oil-photo-lg]' },
    { btn: '[data-fby-add-btn]',              img: '[data-fby-filter-photo-lg]' },
    { btn: '[data-fby-kit-add-btn]',          img: '[data-fby-oil-photo-lg]' },
    { btn: '[data-fby-crosssell-add]',        img: '.fby-crosssell-photo',        ancestor: '.fby-crosssell-row' },
    { btn: '[data-fby-clean-add]',            img: '.fby-clean-photo',            ancestor: '.fby-clean-row' },
    { btn: '[data-fby-modal-add-btn]',        img: '.fby-modal-img',              ancestor: '[data-fby-modal-body]' },
    { btn: '[data-fby-modal-simple-add]',     img: '.fby-modal-img',              ancestor: '[data-fby-modal-body]' },
    { btn: '[data-add-btn]',                  img: '.fby-jobmodal-card-img',      ancestor: '.fby-jobmodal-card' },
    { btn: '[data-fby-productmodal-add-btn]', img: '[data-fby-productmodal-img]', ancestor: '.fby-productmodal' }
  ];

  function prefersReducedMotion(){
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }

  function findImageFor(btn, rule){
    var scope = document;
    if (rule.ancestor){
      var ancestorEl = btn.closest(rule.ancestor);
      if (!ancestorEl) return null;
      scope = ancestorEl;
    }
    return scope.querySelector(rule.img);
  }

  // Several cart_type theme settings (page / drawer / no-js fallback) can
  // each render their own header cart icon, hidden or shown by CSS
  // depending on which is active — so this picks whichever copy is
  // actually visible right now instead of assuming a fixed one.
  function getCartIcon(){
    var candidates = document.querySelectorAll('.header__icon--cart');
    for (var i = 0; i < candidates.length; i++){
      var rect = candidates[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return candidates[i];
    }
    return candidates[0] || null;
  }

  // Derek's follow-up (2026-09-18, later same day): the theme's own
  // "Sticky (hide on scroll down)" header setting slides the whole header
  // — cart icon included — up out of view while someone's scrolled down
  // the page, which is most of the time on a long product list, especially
  // on mobile. The cart icon element is still there and still full-size
  // when that's happening (only its position moves off-screen), so before
  // this fix the star was already flying to the icon's *real* position —
  // it just meant the whole effect could land somewhere above the visible
  // screen, invisible to the shopper.
  //
  // The theme marks a header that has this setting on with a
  // `data-hide-on-scroll-down` attribute, and drives the actual hide/show
  // by toggling an `is-collapsed` class on that header's `.header-section`
  // wrapper (a `position: sticky` element; the class pushes it off-screen
  // with a negative `top`, animated by the theme's own 0.2s CSS
  // transition). Reusing that same class here — rather than adding any
  // new CSS of our own — means this automatically matches however the
  // header is currently styled, and un-collapsing it is exactly the same
  // as a shopper scrolling up: the theme's own scroll listener remains in
  // full control and will happily re-collapse it again on the next
  // scroll-down, same as always.
  function revealCollapsedHeader(){
    var hideEl = document.querySelector('[data-hide-on-scroll-down]');
    var wrapper = hideEl ? hideEl.closest('.header-section') : null;
    if (wrapper && wrapper.classList.contains('is-collapsed')){
      wrapper.classList.remove('is-collapsed');
      return true;
    }
    return false;
  }

  function flashAndBump(destRect){
    var flash = document.createElement('div');
    flash.setAttribute('aria-hidden', 'true');
    flash.style.position = 'fixed';
    flash.style.left = (destRect.left + destRect.width / 2) + 'px';
    flash.style.top = (destRect.top + destRect.height / 2) + 'px';
    flash.style.width = '8px';
    flash.style.height = '8px';
    flash.style.marginLeft = '-4px';
    flash.style.marginTop = '-4px';
    flash.style.borderRadius = '50%';
    flash.style.zIndex = '99998';
    flash.style.pointerEvents = 'none';
    flash.style.background = 'radial-gradient(circle, #ffffff 0%, #FFF700 40%, rgba(255,247,0,0) 75%)';
    document.body.appendChild(flash);

    var flashAnim = flash.animate([
      { transform: 'scale(0.3)', opacity: 0 },
      { transform: 'scale(1)', opacity: 1, offset: 0.3 },
      { transform: 'scale(2.6)', opacity: 0, offset: 1 }
    ], { duration: 550, easing: 'ease-out' });
    flashAnim.onfinish = function(){ flash.remove(); };
    setTimeout(function(){ flash.remove(); }, 700);

    var icon = getCartIcon();
    if (icon){
      icon.animate([
        { transform: 'scale(1)' },
        { transform: 'scale(1.32)', offset: 0.4 },
        { transform: 'scale(0.94)', offset: 0.7 },
        { transform: 'scale(1)' }
      ], { duration: 420, easing: 'ease-out' });
    }
  }

  function fly(imgEl){
    if (!imgEl || prefersReducedMotion()) return;
    var src = imgEl.currentSrc || imgEl.src;
    if (!src) return;

    var srcRect = imgEl.getBoundingClientRect();
    if (srcRect.width === 0 || srcRect.height === 0) return;

    // If the header's currently slid out of view, bring it back down first
    // and give its own 0.2s slide transition a moment to finish, so the
    // star flies to (and flashes at) where the cart icon actually is on
    // screen right now, not to a point above the visible page. The source
    // photo's own position is re-measured after the wait (rare, but cheap
    // to guard against the card reflowing in that quarter-second).
    if (revealCollapsedHeader()){
      setTimeout(function(){ flyToCurrentCartIcon(imgEl, src); }, 240);
      return;
    }
    flyToCurrentCartIcon(imgEl, src);
  }

  function flyToCurrentCartIcon(imgEl, src){
    var srcRect = imgEl.getBoundingClientRect();
    if (srcRect.width === 0 || srcRect.height === 0) return;

    var cartIcon = getCartIcon();
    if (!cartIcon) return;
    var destRect = cartIcon.getBoundingClientRect();
    if (destRect.width === 0 || destRect.height === 0) return;

    var clone = document.createElement('img');
    clone.src = src;
    clone.setAttribute('aria-hidden', 'true');
    clone.style.position = 'fixed';
    clone.style.left = srcRect.left + 'px';
    clone.style.top = srcRect.top + 'px';
    clone.style.width = srcRect.width + 'px';
    clone.style.height = srcRect.height + 'px';
    clone.style.margin = '0';
    clone.style.zIndex = '99999';
    clone.style.pointerEvents = 'none';
    clone.style.borderRadius = '10px';
    clone.style.objectFit = 'contain';
    clone.style.background = '#ffffff';
    clone.style.boxShadow = '0 6px 18px rgba(20,18,16,.28)';
    clone.style.willChange = 'transform, opacity';
    document.body.appendChild(clone);

    var srcCenterX = srcRect.left + srcRect.width / 2;
    var srcCenterY = srcRect.top + srcRect.height / 2;
    var destCenterX = destRect.left + destRect.width / 2;
    var destCenterY = destRect.top + destRect.height / 2;
    var dx = destCenterX - srcCenterX;
    var dy = destCenterY - srcCenterY;
    var destSize = Math.max(destRect.width, destRect.height, 16);
    var destScale = Math.min(destSize / Math.max(srcRect.width, srcRect.height), 1);

    // A "shooting star" arc rather than a straight line: an intermediate
    // keyframe lifts the clone up and over before it curves down/across
    // into the cart icon, with most of the spin happening in that back
    // half of the flight.
    var arcLift = -Math.max(70, Math.min(160, Math.abs(dy) * 0.55 + 40));
    var midScale = 1 - (1 - destScale) * 0.45;

    var anim = clone.animate([
      { transform: 'translate(0px, 0px) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
      { transform: 'translate(' + (dx * 0.45) + 'px, ' + (dy * 0.45 + arcLift) + 'px) scale(' + midScale + ') rotate(200deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + destScale + ') rotate(500deg)', opacity: 0.15, offset: 1 }
    ], {
      duration: 700,
      easing: 'cubic-bezier(.32,.58,.32,1)',
      fill: 'forwards'
    });

    var done = false;
    function finish(){
      if (done) return;
      done = true;
      clone.remove();
      flashAndBump(destRect);
    }
    anim.onfinish = finish;
    // Safety net: WAAPI's onfinish can occasionally not fire (a hidden tab,
    // an interrupted animation) — never leave the clone stuck on screen.
    setTimeout(finish, 850);
  }

  function init(){
    // Listens during the CAPTURE phase, not bubble — and this matters.
    // Every one of these add-to-cart buttons synchronously sets its own
    // `disabled = true` as the very first line of its own click handler
    // (an anti-double-click guard, while the /cart/add.js request is in
    // flight). That handler lives directly on the button itself, so it
    // always runs before a delegated listener sitting on `document` in
    // the ordinary bubble phase ever sees the event — meaning the
    // `btn.disabled` check below would always find the button already
    // disabled, and this would never fire for anything, anywhere (found
    // 2026-09-18, later same day, after Derek reported the effect wasn't
    // showing up on any product). Capture fires top-down, before the
    // event ever reaches the button, so `btn.disabled` here still
    // reflects its real pre-click state.
    document.addEventListener('click', function(e){
      for (var i = 0; i < RULES.length; i++){
        var rule = RULES[i];
        var btn = e.target.closest && e.target.closest(rule.btn);
        if (!btn || btn.disabled) continue;
        var imgEl = findImageFor(btn, rule);
        if (imgEl) fly(imgEl);
        return;
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
